const LOAD_SUPPORT_CONTACTS = 'SUPPORT_CONTACTS/LOAD';

export { LOAD_SUPPORT_CONTACTS };
